<template>
  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <b-overlay :show="loadingAgreement" opacity="0.99">
      <!-- Modal create -->
      <b-modal
        no-close-on-backdrop
        size="xl"
        id="createAgreementResident"
        hide-footer
      >
        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a
              class="nav-link active"
              id="nav-informacoes-convenio"
              data-toggle="tab"
              href="#informacoes-convenio"
              role="tab"
              aria-controls="informacoes-convenio"
              aria-selected="true"
              >INFORMAÇÕES</a
            >
            <a
              class="nav-link"
              id="nav-endereco-convenio"
              data-toggle="tab"
              href="#endereco-convenio"
              role="tab"
              aria-controls="endereco-convenio"
              aria-selected="false"
              >ENDEREÇO</a
            >
          </div>
        </nav>
        <template v-slot:modal-title>NOVO CONVÊNIO</template>
        <form v-on:submit="createAgreement" method="post">
          <div class="tab-content">
            <div
              class="tab-pane fade show active"
              id="informacoes-convenio"
              role="tabpanel"
              aria-labelledby="nav-informacoes-convenio"
            >
              <div class="row p-2">
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <LabelRequiredField label="Escolha o tipo de convênio" />
                  <select v-model="type_of_agreement_id" class="form-control">
                    <option value>Selecione...</option>
                    <option
                      v-for="value in typesOfAgreement"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ value.name }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Nome do convênio</label>
                  <input
                    type="text"
                    v-model="covenant_name"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>N° Carteirinha do convênio </label>
                  <input type="text" v-model="number" class="form-control" />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Tipo/Nome do plano</label>
                  <input
                    type="text"
                    v-model="type_plan_name"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Telefone da central</label>
                  <input
                    type="text"
                    v-mask="'(##) ####-####'"
                    v-model="exchange_phone"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <LabelRequiredField label="Nome do titular" />
                  <input type="text" v-model="name" class="form-control" />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <LabelRequiredField label="Grau de parentesco" />
                  <select v-model="type_of_customer_id" class="form-control">
                    <option value>Selecione...</option>
                    <option
                      v-for="value in typesOfCustomer"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ value.name }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Telefone</label>
                  <input
                    type="text"
                    v-mask="'(##) ####-####'"
                    v-model="phone"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                  <label>Celular</label>
                  <input
                    type="text"
                    v-mask="'(##) # ####-####'"
                    v-model="cell_phone"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-12 col-lg-12 col-md-8 col-sm-8 col-12">
                  <label>Observação</label>
                  <input type="text" v-model="note" class="form-control" />
                </div>
              </div>
            </div>

            <div
              class="tab-pane fade"
              id="endereco-convenio"
              role="tabpanel"
              aria-labelledby="nav-endereco-convenio"
            >
              <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                  <label>CEP</label>
                  <BInputCEP v-model="cep" @retrieved="evOnCEPRetrieved" />
                </div>
                <div class="col-xl-7 col-lg-7 col-md-8 col-sm-6 col-12">
                  <label>Endereço</label>
                  <input type="text" v-model="address" class="form-control" />
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12">
                  <label>Nº</label>
                  <input
                    type="text"
                    v-model="number_address"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-8 col-sm-6 col-12">
                  <label>Bairro</label>
                  <input
                    type="text"
                    v-model="neighborhood"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Cidade</label>
                  <input type="text" v-model="city" class="form-control" />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Estado</label>
                  <select v-model="uf_id" class="form-control">
                    <option value>Selecione...</option>
                    <option
                      v-for="value in ufs"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ value.name }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <label>Referência</label>
                  <input type="text" v-model="reference" class="form-control" />
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <label>Complemento</label>
                  <input
                    type="text"
                    v-model="complement"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <WarningRequiredFields />
              <ErrorsMessages :errors="errors" />
            </div>
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
            >
              <v-btn
                :disabled="loadingCreateAgreement"
                type="submit"
                class="btn-save"
              >
                <i class="fas fa-save mr-2 text-twenty"></i>
                {{ loadingCreateAgreement ? "Carregando" : "SALVAR" }}
              </v-btn>
            </div>
          </div>
        </form>
      </b-modal>
      <!-- /Modal create -->
      <div class="row">
        <div
          class="
            col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12
            pb-0
            d-flex
            align-items-center
          "
        >
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            label="Pesquisar convênios"
            outlined
            dense
          />
        </div>
        <div
          class="
            col-xl-8 col-lg-8 col-md-6 col-sm-6 col-12
            d-flex
            align-items-center
            justify-content-end
          "
        >
          <v-btn
            v-if="permission('write', 'agreement')"
            class="btn-add"
            v-on:click="handleModalCreateAgreement"
          >
            <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
          </v-btn>
        </div>
      </div>
      <div class="v-clean p-5 text-center" v-show="agreements.length == 0">
        <h6 class="text-center upper-text worksansr">
          NENHUM CONVÊNIO CADASTRADO!
        </h6>
      </div>
      <v-data-table
        v-show="agreements.length > 0"
        dense
        v-if="permission('read', 'agreement')"
        :headers="headers"
        :items="agreements"
        :search="search"
        :footer-props="{
          'items-per-page-options': [50, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
        @click:row="handleClickRowTableAgreement"
      >
        <template v-slot:[`item.name`]="{ item }">
          <!-- Modal update agreementsResident -->
          <b-modal
            no-close-on-backdrop
            size="xl"
            :id="`agreementsResident_${String(item.id)}`"
            hide-footer
          >
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a
                  class="nav-link active"
                  id="nav-informacoes-convenio"
                  data-toggle="tab"
                  href="#informacoes-convenio"
                  role="tab"
                  aria-controls="informacoes-convenio"
                  aria-selected="true"
                  >INFORMAÇÕES</a
                >
                <a
                  class="nav-link"
                  id="nav-endereco-convenio"
                  data-toggle="tab"
                  href="#endereco-convenio"
                  role="tab"
                  aria-controls="endereco-convenio"
                  aria-selected="false"
                  >ENDEREÇO</a
                >
              </div>
            </nav>
            <template v-slot:modal-title>
              <span>EDITAR CONVÊNIO</span>
            </template>
            <b-overlay :show="loadingAgreementUpdate" opacity="0.99">
              <WarningMessage
                v-if="!permission('edit', 'agreement')"
                message="Você não tem permissão para modificar convênios"
              />
              <form
                v-if="permission('edit', 'agreement')"
                v-on:submit="updateAgreement"
                method="post"
              >
                <div class="tab-content">
                  <div
                    class="tab-pane fade show active"
                    id="informacoes-convenio"
                    role="tabpanel"
                    aria-labelledby="nav-informacoes-convenio"
                  >
                    <div class="row">
                      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                        <LabelRequiredField
                          label="Escolha o tipo de convênio"
                        />
                        <select
                          v-model="type_of_agreement_id"
                          class="form-control"
                        >
                          <option value>Selecione...</option>
                          <option
                            v-for="value in typesOfAgreement"
                            :key="value.id"
                            :value="value.id"
                          >
                            {{ value.name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                        <label>Nome do convênio</label>
                        <input
                          type="text"
                          v-model="covenant_name"
                          class="form-control"
                        />
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                        <label>N° Carteirinha do convênio</label>
                        <input
                          type="text"
                          v-model="number"
                          class="form-control"
                        />
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                        <label>Tipo/Nome do plano</label>
                        <input
                          type="text"
                          v-model="type_plan_name"
                          class="form-control"
                        />
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                        <label>Telefone da central</label>
                        <input
                          type="text"
                          v-mask="'(##) ####-####'"
                          v-model="exchange_phone"
                          class="form-control"
                        />
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                        <LabelRequiredField label="Nome do titular" />
                        <input
                          type="text"
                          v-model="name"
                          class="form-control"
                        />
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                        <LabelRequiredField label="Grau de parentesco" />
                        <select
                          v-model="type_of_customer_id"
                          class="form-control"
                        >
                          <option value>Selecione...</option>
                          <option
                            v-for="value in typesOfCustomer"
                            :key="value.id"
                            :value="value.id"
                          >
                            {{ value.name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                        <label>Telefone</label>
                        <input
                          type="text"
                          v-mask="'(##) ####-####'"
                          v-model="phone"
                          class="form-control"
                        />
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                        <label>Celular</label>
                        <input
                          type="text"
                          v-mask="'(##) # ####-####'"
                          v-model="cell_phone"
                          class="form-control"
                        />
                      </div>
                      <div class="col-xl-12 col-lg-12 col-md-8 col-sm-8 col-12">
                        <label>Observação</label>
                        <input
                          type="text"
                          v-model="note"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="endereco-convenio"
                    role="tabpanel"
                    aria-labelledby="nav-endereco-convenio"
                  >
                    <div class="row">
                      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-2">
                        <label>CEP</label>
                        <BInputCEP
                          v-model="cep"
                          @retrieved="evOnCEPRetrieved"
                        />
                      </div>
                      <div class="col-xl-7 col-lg-7 col-md-8 col-sm-6 col-12">
                        <label>Endereço</label>
                        <input
                          type="text"
                          v-model="address"
                          class="form-control"
                        />
                      </div>
                      <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12">
                        <label>Nº</label>
                        <input
                          type="text"
                          v-model="number_address"
                          class="form-control"
                        />
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-8 col-sm-6 col-12">
                        <label>Bairro</label>
                        <input
                          type="text"
                          v-model="neighborhood"
                          class="form-control"
                        />
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                        <label>Cidade</label>
                        <input
                          type="text"
                          v-model="city"
                          class="form-control"
                        />
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                        <label>Estado</label>
                        <select v-model="uf_id" class="form-control">
                          <option value>Selecione...</option>
                          <option
                            v-for="value in ufs"
                            :key="value.id"
                            :value="value.id"
                          >
                            {{ value.name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <label>Referência</label>
                        <input
                          type="text"
                          v-model="reference"
                          class="form-control"
                        />
                      </div>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <label>Complemento</label>
                        <input
                          type="text"
                          v-model="complement"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <WarningRequiredFields />
                  <ErrorsMessages :errors="errors" />
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <h6 class="mb-0 worksansr">
                    Criação:
                    {{ formatDate(item.created_at) }}
                  </h6>
                  <h6 class="mb-0 worksansr">
                    Última alteração:
                    {{ formatDate(item.updated_at) }}
                  </h6>
                </div>
                <div class="row">
                  <div
                    class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 text-left"
                  >
                    <v-btn
                      class="btn-return m-1"
                      @click="
                        $bvModal.hide(`agreementsResident_${String(item.id)}`)
                      "
                    >
                      <i class="fas fa-arrow-left mr-2 text-twenty"></i> VOLTAR
                    </v-btn>
                  </div>
                  <div
                    class="
                      col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12
                      text-right
                    "
                  >
                    <confirmation-dialog
                      v-if="permission('remove', 'agreement')"
                      message-title="CONFIRMAÇÃO"
                      message-body="TEM CERTEZA QUE DESEJA REMOVER?"
                      open-left-icon="fa-trash"
                      open-class="btn-delete"
                      open-text="REMOVER"
                      @yes="deleteAgreement(item)"
                    />
                    <v-btn
                      v-if="permission('edit', 'agreement')"
                      :disabled="loadingUpdateAgreement"
                      type="submit"
                      class="btn-save m-1"
                    >
                      <i class="fas fa-save mr-2 text-twenty"></i>
                      {{ loadingUpdateAgreement ? "Carregando" : "SALVAR" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </b-overlay>
          </b-modal>
          <!-- /Modal update agreementsResident -->
          {{ item.name }}
        </template>
      </v-data-table>
      <errors-messages :errors="errors" />
    </b-overlay>
  </div>
</template>

<script>
import api from "../../services/api";
import permission from "../../lib/permission";
import toast from "../../lib/ToastNotification";
import { formatDate } from "../../lib/format";

import ErrorsMessages from "../Components/ErrorsMessages";
import WarningMessage from "../Components/WarningMessage";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import LabelRequiredField from "../Components/LabelRequiredField";
import BInputCEP from "../Components/BInputCEP.vue";
import ConfirmationDialog from "../Components/ConfirmationDialog.vue";

export default {
  name: "Agreement",
  components: {
    ErrorsMessages,
    WarningMessage,
    WarningRequiredFields,
    LabelRequiredField,
    BInputCEP,
    ConfirmationDialog,
  },
  props: {
    rest_home_id: [String, Number],
    resident_id: [String, Number],
    user_id: [String, Number],
  },
  data() {
    return {
      errors: [],
      search: "",
      headers: [
        { text: "Grau de parentesco", value: "type_of_customer_name" },
        { text: "Tipo do convênio", value: "type_of_agreement_name" },
        { text: "Nome do convênio", value: "covenant_name" },
        { text: "Nome do títular", value: "name" },
      ],
      stepAgreement: 1,
      ufs: [],
      typesOfAgreement: [],
      typesOfCustomer: [],
      agreements: [],
      id: "",
      type_of_agreement_id: "",
      uf_id: "",
      number: "",
      covenant_name: "",
      type_plan_name: "",
      exchange_phone: "",
      name: "",
      phone: "",
      cell_phone: "",
      type_of_customer_id: "",
      note: "",
      cep: "",
      address: "",
      number_address: "",
      neighborhood: "",
      city: "",
      reference: "",
      complement: "",
      loadingCreateAgreement: false,
      loadingUpdateAgreement: false,
      loadingAgreementUpdate: false,
      loadingAgreement: true,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    permission,
    formatDate,
    handleClickRowTableAgreement(item) {
      this.handleModalAgreementResident(item.id);
      this.$bvModal.show(`agreementsResident_${String(item.id)}`);
    },

    async evOnCEPRetrieved(value) {
      this.cep = value.cep;
      this.city = value.localidade || this.city;
      this.neighborhood = value.bairro || this.neighborhood;
      // this.complement = value.complemento || this.complement;
      this.address = value.logradouro || this.address;

      const matched_uf = this.ufs.find(
        (item) => item.initials.toLowerCase() === value.uf.toLowerCase()
      );
      if (matched_uf) this.uf_id = matched_uf.id;
    },

    async retrieve() {
      if (this.errors.length == 0) await this.getAgreementResidents();
      if (this.errors.length == 0) await this.getUfs();
      if (this.errors.length == 0) await this.getTypesOfAgreement();
      if (this.errors.length == 0) await this.getTypesOfCustomer();
    },
    async getAgreementResidents(page = 1) {
      try {
        this.loadingAgreement = true;

        const { resident_id } = this;

        let params = {
          resident_id,
          page,
        };

        const response = await api.get(
          "/rest-home/resident/agreements/paginate",
          {
            params,
          }
        );

        const { error, errors, agreements } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.agreements = agreements;
          this.errors = [];
        }

        this.loadingAgreement = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getUfs() {
      try {
        const response = await api.get("/ufs");

        const { error, errors, ufs } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.ufs = ufs;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getTypesOfAgreement() {
      try {
        const response = await api.get("/rest-home/type-agreement/all");

        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.typesOfAgreement = types;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getTypesOfCustomer() {
      try {
        const response = await api.get("/types-of-customers");

        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.typesOfCustomer = types;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async createAgreement(event) {
      try {
        event.preventDefault();

        this.loadingCreateAgreement = true;

        const {
          user_id,
          resident_id,
          type_of_agreement_id,
          uf_id,
          number,
          covenant_name,
          type_plan_name,
          exchange_phone,
          name,
          phone,
          cell_phone,
          type_of_customer_id,
          note,
          cep,
          address,
          number_address,
          neighborhood,
          city,
          reference,
          complement,
        } = this;

        let params = {
          user_id,
          resident_id,
          type_of_agreement_id,
          uf_id,
          number,
          covenant_name,
          type_plan_name,
          exchange_phone,
          name,
          phone,
          cell_phone,
          type_of_customer_id,
          note,
          cep,
          address,
          number_address,
          neighborhood,
          city,
          reference,
          complement,
        };

        const response = await api.post(
          "/rest-home/resident/agreement",
          params
        );

        const { error, errors } = response.data;

        if (!error) {
          this.$bvModal.hide("createAgreementResident");
          this.getAgreementResidents();
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loadingCreateAgreement = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreateAgreement() {
      this.errors = [];
      this.stepAgreement = 1;
      this.type_of_agreement_id = "";
      this.uf_id = "";
      this.number = "";
      this.covenant_name = "";
      this.type_plan_name = "";
      this.exchange_phone = "";
      this.name = "";
      this.phone = "";
      this.cell_phone = "";
      this.type_of_customer_id = "";
      this.note = "";
      this.cep = "";
      this.address = "";
      this.number_address = "";
      this.neighborhood = "";
      this.city = "";
      this.reference = "";
      this.complement = "";
      this.$bvModal.show("createAgreementResident");
    },
    async updateAgreement(event) {
      try {
        event.preventDefault();

        this.loadingUpdateAgreement = true;

        const {
          user_id,
          id,
          resident_id,
          type_of_agreement_id,
          uf_id,
          number,
          covenant_name,
          type_plan_name,
          exchange_phone,
          name,
          phone,
          cell_phone,
          type_of_customer_id,
          note,
          cep,
          address,
          number_address,
          neighborhood,
          city,
          reference,
          complement,
        } = this;

        let params = {
          user_id,
          id,
          resident_id,
          type_of_agreement_id,
          uf_id,
          number,
          covenant_name,
          type_plan_name,
          exchange_phone,
          name,
          phone,
          cell_phone,
          type_of_customer_id,
          note,
          cep,
          address,
          number_address,
          neighborhood,
          city,
          reference,
          complement,
        };

        const response = await api.patch(
          "/rest-home/resident/agreement",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(`agreementsResident_${String(id)}`);
          this.getAgreementResidents();
          toast(message, "success");
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loadingUpdateAgreement = false;
      } catch (error) {
        console.log(error);
      }
    },
    async handleModalAgreementResident(id) {
      try {
        this.errors = [];
        this.loadingAgreementUpdate = true;
        this.stepAgreement = 1;

        this.id = id;

        const { resident_id } = this;

        const response = await api.get("/rest-home/resident/agreement", {
          params: { id, resident_id },
        });

        const { error, errors, agreement } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.id = agreement.id;
          this.type_of_agreement_id = agreement.type_of_agreement_id;
          this.uf_id = agreement.uf_id;
          this.number = agreement.number;
          this.covenant_name = agreement.covenant_name;
          this.type_plan_name = agreement.type_plan_name;
          this.exchange_phone = agreement.exchange_phone;
          this.name = agreement.name;
          this.phone = agreement.phone;
          this.cell_phone = agreement.cell_phone;
          this.type_of_customer_id = agreement.type_of_customer_id;
          this.note = agreement.note;
          this.cep = agreement.cep;
          this.address = agreement.address;
          this.number_address = agreement.number_address;
          this.neighborhood = agreement.neighborhood;
          this.city = agreement.city;
          this.reference = agreement.reference;
          this.complement = agreement.complement;
        }
        this.loadingAgreementUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async deleteAgreement(agreements) {
      try {
        const { id, rest_home_id } = agreements;

        const { user_id } = this;

        let data = { user_id, id, rest_home_id };

        const response = await api.delete("/rest-home/resident/agreement", {
          data,
        });

        const { error, message } = response.data;

        if (!error) {
          this.getAgreementResidents();
          toast(message, "success");
        } else {
          toast(message, "error");
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
